<template id="home">
  <v-container fill-height fluid class="pl-5 pr-5">
    <v-row>
      <v-col cols="12">
        <v-row height="100%" align="center" justify="center">
          <div style="border: 1px solid #ccc;">
            <iframe title="eTags" v-if="selectedTags !== null && selectedTags.length > 0" id="etags" name="etags" class="buttonPreview" style="border: none; min-height: 595.3pt; width: 873.1pt;" :srcdoc="etagHTML"></iframe>
            <iframe title="eTag Preview" v-if="selectedTags === null || selectedTags.length === 0" id="preview" name="preview" class="buttonPreview" style="display: block;border: none; height: 107.2mm; width: 75.6mm;" :srcdoc="iframeHTML"></iframe>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  template: '#home',
  data() {
    return {
      message: '',
      subMessage: '',
      loading: false,
      colorSwitch: false,
      tempWidth: undefined,
      borderRadiusDefault: 3,
    }
  },
  computed: {
    selectedTags() {
      return this.$store.state.selectedTags
    },
    style() {
      return this.$store.state.style
    },
    etagHTML() {
      return this.$store.getters.etagHtml
    },
    iframeHTML() {

      history.pushState(
        {},
        null,
        this.$route.path +
          '?organizationUUID=' +
          this.$store.state.organizationUUID +
          '&values=' +
          encodeURIComponent(JSON.stringify(this.$store.state.values))
      )

      return this.$store.getters.iframeHtml
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Inconsolata&display=swap');

  .codeOutput {
    font-weight: bold;
    font-family: 'Inconsolata', monospace;
    padding: 10px;
    background-color: #000;
    color: #fff;
  }

  .codeSimple {
    padding: 10px;
    background-color: #000;
    color: #fff;
    width: 100%;
  }
</style>
